import React from 'react';
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

export class MyobOnboarding extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (!code) {
      this.props.history.push("/settings/myob")
    }
    else {
      this.getToken(code);
    }
  }

  state = {
    statusView: 'CompanyFile',
    importDone: false,
    companyFiles: '',
    settings: {},
    cfURI: '',
    cfUsername: '',
    cfPassword: '',
    refreshToken: ''
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  getToken = async (code) => {
    var decodeCode = decodeURI(code);
    let requestParams = {
      'code': decodeCode
    }
    axios.post('/myob/auth/token', requestParams)
        .then(data => {
            console.log(data.token);
            this.setState({refreshToken: data.token})
            this.fetchSupplierData();
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to exchange code for token')
        })
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          var settings = JSON.parse(data[0].settings)
          console.log(settings);
          this.setState({
            settings: settings,
          });
          // Save token
          this.updateSettings()
        })
        .catch (err => {
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSettings = async () => {
    let settings = this.state.settings
    let integration = {}
    integration.type = 'myob'
    integration.enabled = true
    integration.cfURI = this.state.cfURI
    integration.cfUsername = this.state.cfUsername
    integration.cfPassword = this.state.cfPassword
    integration.refreshToken = this.state.refreshToken
    settings.integration = integration
    let requestParams = {
      'settings': settings
    }
    axios.post('/user/update/settings', requestParams)
        .then(data => {
          console.log(data);
          this.fetchCompanyFiles()
        })
        .catch (err => {
          console.log(err); 
          Rollbar.error(err)
          toast.error("Error: Could not save settings!");
        })
  }

  fetchCompanyFiles = async () => {
    axios.get('/myob/companyfiles')
        .then(data => {
          console.log(data);
          this.setState({
            companyFiles: data,
            cfURI: data[0].Uri
          });
        })
        .catch(err => {
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch company files')
        })
  }

  checkCfCredentials = async () =>{
    toast.warning('Verifying Credentials...please wait', {autoClose: false})
    let requestParams = {
      'username': this.state.cfUsername,
      'password': this.state.cfPassword,
      'cfURI': this.state.cfURI
    }
    axios.post('/myob/verify/credentials', requestParams)
        .then(data => {
          toast.dismiss()
          console.log(data);
          this.updateSettings()
          this.setState({statusView: 'Import'})
        })
        .catch (err => {
          toast.dismiss()
          console.log(err); 
          Rollbar.error(err)
          toast.error("Error: Username or Password incorrect!");
        })
  }

  importData = async () => {
    toast.warning('Syncing Data...please wait', {autoClose: false})
    axios.get('/myob/import')
        .then(data => {
          console.log(data);
          this.setState({
            importDone: true
          });
          toast.dismiss()
        })
        .catch (err => {
          toast.dismiss()
          console.log(err);
          Rollbar.error(err)
          toast.error("Error: Could not import data!");
        })
  }

    render() {
        return (
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center onboarding-logo-section">
                <h4>Setup MYOB Integration</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.statusView === 'CompanyFile' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Company File</h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label>Company File</label>
                        {this.state.companyFiles ?
                        <select className="form-control" value={this.state.cfURI} onChange={this.handleChange} name="cfURI">
                          {this.state.companyFiles.map((data, i) =>
                            <option key={i} value={data.Uri}>{data.Name}</option>
                          )}
                        </select>: null}
                      </div>
                      <div className="form-group">
                        <label for="cfUsername">CF Username:</label>
                        <input type="text" className="form-control" value={this.state.cfUsername} onChange={this.handleChange} name="cfUsername" />
                      </div>
                      <div className="form-group">
                        <label for="cfPassword">CF Password:</label>
                        <input type="password" className="form-control" value={this.state.cfPassword} onChange={this.handleChange} name="cfPassword" />
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-6 text-left"><button type="button" className="btn btn-primary" disabled>Previous</button></div>
                    <div className="col-md-6 text-right"><button type="button" className={this.state.cfUsername && this.state.cfURI ? "btn btn-primary" : "btn btn-primary disabled"} onClick={() => this.checkCfCredentials()} >Next</button></div>
                  </div>
                </div>) : null }
                {this.state.statusView === 'Import' ? (
                <div className="modal-dialog allow-click">
                  <div className="modal-content">
                    <div className="modal-header text-center">
                      <h4 className="modal-title ">Import MYOB Data</h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label>Import Products/Price Lists</label>
                        <div>
                          <button type="button" className="btn btn-warning" disabled={this.state.importDone} onClick={() => this.importData()}>Start</button>
                        </div>
                        <small className="form-text text-muted">
                          This will import all active and inventoried products and their associated price matrix levels. Customers can be individually selected/import on the customers page after this.
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="row pad-top">
                    <div className="col-md-6 text-left"><button type="button" className="btn btn-primary" onClick={() => this.setState({ statusView: 'CompanyFile' })} >Previous</button></div>
                    <div className="col-md-6 text-right"><button type="button" className={this.state.importDone ? "btn btn-primary" : "btn btn-primary disabled"} onClick={() => this.props.history.push("/settings/myob")}>Finish</button></div>
                  </div>
                </div>) : null }
              </div>
            </div>
          </div>
        );
    }
}
